(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContratController', ContratController);

    ContratController.$inject = ['$q', '$scope', '$state', '$filter', 'Contrat', 'Principal', 'ParseLinks', '$timeout', 'AlertService', 'pagingParams', 'paginationConstants', 'PortefeuilleContrat', 'ContratSearch', 'ContractType', 'ContractProfil', 'ServiceVendu'];

    function ContratController($q, $scope, $state, $filter, Contrat, Principal, ParseLinks, $timeout, AlertService, pagingParams, paginationConstants, PortefeuilleContrat, ContratSearch, ContractType, ContractProfil, ServiceVendu) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.getAppliedFilterCount = getAppliedFilterCount;
        vm.openCalendar = openCalendar;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.etat = $state.params.etat ? $state.params.etat.split(',') : [];
        vm.etatOptions = ['PROSPECT', 'ACTIVE', 'DORMANT', 'FIRST_REMINDER', 'SECOND_REMINDER', 'LITIGATION', 'CLOSED'];
        vm.etatsContrat = ['PROSPECT', 'ACTIVE', 'DORMANT', 'FIRST_REMINDER', 'SECOND_REMINDER', 'LITIGATION', 'CLOSED'];

        vm.portefeuilleContrats = PortefeuilleContrat.query({offset: 0, size: 1000, sort: 'libelle,asc'});
        vm.contractTypes = ContractType.query({offset: 0, size: 1000, sort: 'label,asc'});
        vm.contractProfils = ContractProfil.query({offset: 0, size: 1000, sort: 'libelle,asc'});
        vm.serviceVendus = ServiceVendu.queryInclDeleted({offset: 0, size: 1000, sort: 'libelle,asc'});

        vm.onlinePaymentType = $state.params.onlinePaymentType;
        vm.onlinePaymentQuery = $state.params.onlinePaymentQuery;
        vm.onlinePaymentActive = $state.params.onlinePaymentActive;
        vm.hasEmail = $state.params.hasEmail;
        vm.hasPhone = $state.params.hasPhone;
        vm.searchQuery = $state.params.searchQuery;
        vm.compteurFerme = $state.params.compteurFerme;
        vm.currentBalanceSigne = $state.params.currentBalanceSigne;
        vm.currentBalanceValue = $state.params.currentBalanceValue;
        vm.tooMuchPaid = $state.params.tooMuchPaid === 'true';
        vm.filterBalanceWithService = $state.params.filterBalanceWithService === 'true';
        vm.minAmountPaid = $state.params.minAmountPaid;
        vm.minAmountBilled = $state.params.minAmountBilled;
        vm.maxWaterConsumption = $state.params.maxWaterConsumption;
        vm.date = {
            startDate: $state.params.startDate ? new Date($state.params.startDate) : null,
            endDate: $state.params.endDate ? new Date($state.params.endDate) : null
        };
        vm.toDatePayment = $state.params.toDatePayment ? new Date($state.params.toDatePayment) : null;
        vm.toDateBilling = $state.params.toDateBilling ? new Date($state.params.toDateBilling) : null;
        vm.toDateWaterConsumption = $state.params.toDateWaterConsumption ? new Date($state.params.toDateWaterConsumption) : null;

        vm.datePickerOpenStatus = {
            toDatePayment: false,
            toDateBilling: false,
            toDateWaterConsumption: false
        };

        hydrateSelectedItems();
        hydrateAreaSelection();
        vm.loadAll();

        vm.download = function() {
            Contrat.downloadcsv({
                agenceId: vm.agenceId ? vm.agenceId.map(function(elem) { return elem.id; }).join(',') : null,
                nom: vm.searchQuery,
                compteurFerme: vm.compteurFerme,
                portefeuilleContrat: vm.portefeuilleContrat ? vm.portefeuilleContrat.map(function(elem) { return elem.id; }).join(',') : null,
                contractType: vm.contractType ? vm.contractType.map(function(elem) { return elem.id; }).join(',') : null,
                contractProfil: vm.contractProfil ? vm.contractProfil.map(function(elem) { return elem.id; }).join(',') : null,
                serviceVendu: vm.serviceVendu ? vm.serviceVendu.map(function(elem) { return elem.id; }).join(',') : null,
                etat: vm.etat && vm.etat.length ? vm.etat.join(',') : null,
                fromDate: $filter('date')(vm.date.startDate, 'yyyy-MM-dd'),
                toDate: $filter('date')(vm.date.endDate, 'yyyy-MM-dd'),
                onlinePaymentType: vm.onlinePaymentType,
                onlinePaymentQuery: vm.onlinePaymentQuery,
                onlinePaymentActive: vm.onlinePaymentActive,
                hasEmail: vm.hasEmail,
                hasPhone: vm.hasPhone,
                currentBalanceSigne: vm.currentBalanceSigne,
                currentBalanceValue: vm.currentBalanceValue,
                tooMuchPaid: vm.tooMuchPaid,
                filterBalanceWithService: vm.filterBalanceWithService,
                minAmountPaid: vm.minAmountPaid,
                toDatePayment: $filter('date')(vm.toDatePayment, 'yyyy-MM-dd'),
                minAmountBilled: vm.minAmountBilled,
                toDateBilling: $filter('date')(vm.toDateBilling, 'yyyy-MM-dd'),
                maxWaterConsumption: vm.maxWaterConsumption,
                toDateWaterConsumption: $filter('date')(vm.toDateWaterConsumption, 'yyyy-MM-dd')
            }, function(content) {
                var url = URL.createObjectURL(content.response);
                var a = document.createElement('a');
                a.href = url;
                a.download = content.fileName;
                a.target = '_blank';
                a.click();
            });
        };

        vm.downloadService = function() {
            Contrat.downloadServicecsv({}, function(content) {
                var url = URL.createObjectURL(content.response);
                var a = document.createElement('a');
                a.href = url;
                a.download = content.fileName;
                a.target = '_blank';
                a.click();
            });
        };

        vm.downloadDetailServiceNotClosedcsv = function() {
            Contrat.downloadDetailServiceNotClosedcsv({}, function(content) {
                var url = URL.createObjectURL(content.response);
                var a = document.createElement('a');
                a.href = url;
                a.download = content.fileName;
                a.target = '_blank';
                a.click();
            });
        };

        function hydrateSelectedItems() {
            hydrateParamCollection('portefeuilleContrat', vm.portefeuilleContrats, 'portefeuilleContrat', 'portefeuilleContratNotPromise');
            hydrateParamCollection('contractType', vm.contractTypes, 'contractType', 'contractTypeNotPromise');
            hydrateParamCollection('contractProfil', vm.contractProfils, 'contractProfil', 'contractProfilNotPromise');
            hydrateParamCollection('serviceVendu', vm.serviceVendus, 'serviceVendu', 'serviceVenduNotPromise');
        }

        function hydrateParamCollection(paramName, resource, rawKey, selectedKey) {
            if (!$state.params[paramName]) {
                return;
            }

            vm[rawKey] = $state.params[paramName].split(',').map(function(elem) {
                return {id: elem};
            });

            if (resource && resource.$promise) {
                resource.$promise.then(function(values) {
                    vm[selectedKey] = [];
                    $state.params[paramName].split(',').forEach(function(item) {
                        var match = values.find(function(obj) {
                            return String(obj.id) === String(item);
                        });
                        if (match) {
                            vm[selectedKey].push(match);
                        }
                    });
                });
            }
        }

        function hydrateAreaSelection() {
            vm.agencesRattachement = [];
            vm.agenceIdNotPromise = [];

            if ($state.params.agenceId) {
                vm.agenceId = $state.params.agenceId.split(',').map(function(elem) {
                    return {id: elem};
                });
            }

            Principal.identity().then(function(account) {
                if (account && account.agencesRattachement && account.agencesRattachement.length) {
                    bindAreaSelection(account);
                    return;
                }

                Principal.identity(true).then(function(refreshedAccount) {
                    if (refreshedAccount && refreshedAccount.agencesRattachement && refreshedAccount.agencesRattachement.length) {
                        bindAreaSelection(refreshedAccount);
                    }
                });
            });

            function bindAreaSelection(account) {
                vm.agencesRattachement = account.agencesRattachement;
                vm.agenceIdNotPromise = [];

                if (vm.agenceId && vm.agenceId.length > 0) {
                    $state.params.agenceId.split(',').forEach(function(item) {
                        var match = account.agencesRattachement.find(function(obj) {
                            return String(obj.id) === String(item);
                        });
                        if (match) {
                            vm.agenceIdNotPromise.push(match);
                        }
                    });
                }
            }
        }

        function hasActiveFilters() {
            return !!(
                vm.searchQuery ||
                (vm.etat && vm.etat.length) ||
                vm.compteurFerme ||
                vm.portefeuilleContrat ||
                vm.contractType ||
                vm.contractProfil ||
                vm.serviceVendu ||
                vm.date.startDate ||
                vm.date.endDate ||
                vm.onlinePaymentType ||
                vm.onlinePaymentQuery ||
                vm.onlinePaymentActive ||
                vm.hasEmail ||
                vm.hasPhone ||
                vm.agenceId ||
                isCurrentBalanceApplied() ||
                vm.tooMuchPaid ||
                vm.filterBalanceWithService ||
                isThresholdApplied(vm.minAmountPaid, vm.toDatePayment) ||
                isThresholdApplied(vm.minAmountBilled, vm.toDateBilling) ||
                isThresholdApplied(vm.maxWaterConsumption, vm.toDateWaterConsumption)
            );
        }

        function isCurrentBalanceApplied() {
            return !!(vm.currentBalanceSigne && vm.currentBalanceValue !== null && vm.currentBalanceValue !== undefined && vm.currentBalanceValue !== '');
        }

        function isThresholdApplied(amount, date) {
            return !!(amount !== null && amount !== undefined && amount !== '' && date);
        }

        function getAppliedFilterCount(section) {
            var counters = {
                main: 0,
                reporting: 0,
                online: 0
            };

            if (vm.searchQuery) { counters.main++; }
            if (vm.etat && vm.etat.length) { counters.main++; }
            if (vm.compteurFerme) { counters.main++; }
            if (vm.portefeuilleContratNotPromise && vm.portefeuilleContratNotPromise.length) { counters.main++; }
            if (vm.contractTypeNotPromise && vm.contractTypeNotPromise.length) { counters.main++; }
            if (vm.contractProfilNotPromise && vm.contractProfilNotPromise.length) { counters.main++; }
            if (vm.agenceIdNotPromise && vm.agenceIdNotPromise.length) { counters.main++; }
            if (vm.date.startDate || vm.date.endDate) { counters.main++; }
            if (vm.hasEmail) { counters.main++; }
            if (vm.hasPhone) { counters.main++; }

            if (vm.serviceVenduNotPromise && vm.serviceVenduNotPromise.length) { counters.reporting++; }
            if (isCurrentBalanceApplied()) { counters.reporting++; }
            if (vm.filterBalanceWithService) { counters.reporting++; }
            if (vm.tooMuchPaid) { counters.reporting++; }
            if (isThresholdApplied(vm.minAmountPaid, vm.toDatePayment)) { counters.reporting++; }
            if (isThresholdApplied(vm.minAmountBilled, vm.toDateBilling)) { counters.reporting++; }
            if (isThresholdApplied(vm.maxWaterConsumption, vm.toDateWaterConsumption)) { counters.reporting++; }

            if (vm.onlinePaymentType) { counters.online++; }
            if (vm.onlinePaymentQuery) { counters.online++; }
            if (vm.onlinePaymentActive) { counters.online++; }

            return counters[section] || 0;
        }

        function loadAll() {
            vm.wait = true;
            vm.currentSearch = hasActiveFilters();

            ContratSearch.query({
                agenceId: vm.agenceId ? vm.agenceId.map(function(elem) { return elem.id; }).join(',') : null,
                nom: vm.searchQuery,
                compteurFerme: vm.compteurFerme,
                portefeuilleContrat: vm.portefeuilleContrat ? vm.portefeuilleContrat.map(function(elem) { return elem.id; }).join(',') : null,
                contractType: vm.contractType ? vm.contractType.map(function(elem) { return elem.id; }).join(',') : null,
                contractProfil: vm.contractProfil ? vm.contractProfil.map(function(elem) { return elem.id; }).join(',') : null,
                serviceVendu: vm.serviceVendu ? vm.serviceVendu.map(function(elem) { return elem.id; }).join(',') : null,
                etat: vm.etat && vm.etat.length ? vm.etat.join(',') : null,
                fromDate: $filter('date')(vm.date.startDate, 'yyyy-MM-dd'),
                toDate: $filter('date')(vm.date.endDate, 'yyyy-MM-dd'),
                onlinePaymentType: vm.onlinePaymentType,
                onlinePaymentQuery: vm.onlinePaymentQuery,
                onlinePaymentActive: vm.onlinePaymentActive,
                hasEmail: vm.hasEmail,
                hasPhone: vm.hasPhone,
                currentBalanceSigne: vm.currentBalanceSigne || null,
                currentBalanceValue: vm.currentBalanceValue,
                tooMuchPaid: vm.tooMuchPaid || null,
                filterBalanceWithService: vm.filterBalanceWithService || null,
                minAmountPaid: vm.minAmountPaid,
                toDatePayment: $filter('date')(vm.toDatePayment, 'yyyy-MM-dd'),
                minAmountBilled: vm.minAmountBilled,
                toDateBilling: $filter('date')(vm.toDateBilling, 'yyyy-MM-dd'),
                maxWaterConsumption: vm.maxWaterConsumption,
                toDateWaterConsumption: $filter('date')(vm.toDateWaterConsumption, 'yyyy-MM-dd'),
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                return [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            }

            function onSuccess(data, headers) {
                vm.wait = false;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.contrats = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                vm.wait = false;
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                searchQuery: vm.searchQuery,
                compteurFerme: vm.compteurFerme,
                startDate: vm.date.startDate,
                endDate: vm.date.endDate,
                agenceId: vm.agenceIdNotPromise ? vm.agenceIdNotPromise.map(function(elem) { return elem.id; }).join(',') : null,
                contractType: vm.contractTypeNotPromise ? vm.contractTypeNotPromise.map(function(elem) { return elem.id; }).join(',') : null,
                contractProfil: vm.contractProfilNotPromise ? vm.contractProfilNotPromise.map(function(elem) { return elem.id; }).join(',') : null,
                serviceVendu: vm.serviceVenduNotPromise ? vm.serviceVenduNotPromise.map(function(elem) { return elem.id; }).join(',') : null,
                portefeuilleContrat: vm.portefeuilleContratNotPromise ? vm.portefeuilleContratNotPromise.map(function(elem) { return elem.id; }).join(',') : null,
                etat: vm.etat && vm.etat.length ? vm.etat.join(',') : null,
                currentSearch: vm.currentSearch,
                onlinePaymentType: vm.onlinePaymentType,
                onlinePaymentQuery: vm.onlinePaymentQuery,
                onlinePaymentActive: vm.onlinePaymentActive,
                hasEmail: vm.hasEmail,
                hasPhone: vm.hasPhone,
                currentBalanceSigne: vm.currentBalanceSigne || null,
                currentBalanceValue: vm.currentBalanceValue,
                tooMuchPaid: vm.tooMuchPaid || null,
                filterBalanceWithService: vm.filterBalanceWithService || null,
                minAmountPaid: vm.minAmountPaid,
                toDatePayment: vm.toDatePayment,
                minAmountBilled: vm.minAmountBilled,
                toDateBilling: vm.toDateBilling,
                maxWaterConsumption: vm.maxWaterConsumption,
                toDateWaterConsumption: vm.toDateWaterConsumption
            });
        }

        function search() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = '';
            vm.reverse = false;
            vm.currentSearch = true;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.compteurFerme = null;
            vm.date.startDate = null;
            vm.date.endDate = null;
            vm.portefeuilleContrat = null;
            vm.portefeuilleContratNotPromise = null;
            vm.contractType = null;
            vm.contractTypeNotPromise = null;
            vm.contractProfil = null;
            vm.contractProfilNotPromise = null;
            vm.serviceVendu = null;
            vm.serviceVenduNotPromise = null;
            vm.onlinePaymentType = null;
            vm.onlinePaymentQuery = null;
            vm.onlinePaymentActive = null;
            vm.hasEmail = null;
            vm.hasPhone = null;
            vm.agenceId = null;
            vm.agenceIdNotPromise = null;
            vm.currentBalanceSigne = null;
            vm.currentBalanceValue = null;
            vm.tooMuchPaid = false;
            vm.filterBalanceWithService = false;
            vm.minAmountPaid = null;
            vm.toDatePayment = null;
            vm.minAmountBilled = null;
            vm.toDateBilling = null;
            vm.maxWaterConsumption = null;
            vm.toDateWaterConsumption = null;
            vm.etat = [];
            vm.currentSearch = null;
            vm.transition();
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
